import React from 'react';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import PushPinIcon from '@mui/icons-material/PushPin';
import { IconButton, SxProps } from '@mui/material';
import { Tooltip } from 'framework/ui/mui-builder';
import { useListContext } from 'framework/list';
import { TimelineContextData } from 'framework/ui/timeline';
import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import { DEFAULT_ERROR_MESSAGE } from 'framework/form';

const MAX_PIN = 3;

type PinTimelineButtonProps = {
  pinStatus: boolean;
  disabled?: boolean;
  pinMethod: () => Promise<any>;
  sx?: SxProps;
};

const PinTimelineButton = ({ pinMethod, pinStatus, disabled, sx = {} }: PinTimelineButtonProps) => {
  const { countPinElements = 0 }: TimelineContextData = useListContext();
  const { addMessage } = useMessageService();

  const pinCallback = async () => {
    try {
      await pinMethod();
    } catch {
      addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  return (
    <IconButton
      disabled={(!pinStatus && Number(countPinElements) >= MAX_PIN) || disabled}
      onClick={pinCallback}
      sx={{ p: 0.5 }}
    >
      <Tooltip title={pinStatus ? 'Unpin' : 'Pin'}>
        {pinStatus ? (
          <PushPinIcon sx={{ color: 'var(--mui-palette-primary-main)', ...sx }} />
        ) : (
          <PushPinOutlinedIcon sx={{ transform: 'rotate(45deg)', ...sx }} />
        )}
      </Tooltip>
    </IconButton>
  );
};

export default PinTimelineButton;
